import {environment} from '../../environments/environment';
import {InteractionType, IPublicClientApplication, PublicClientApplication} from '@azure/msal-browser';
import {MsalGuardConfiguration, MsalInterceptorConfiguration} from '@azure/msal-angular';

export const b2cPolicies = {
  names: {
    signUpSignIn: environment.msalConfig.signInPolicy
  },
  authorities: {
    signUpSignIn: {
      authority: `https://${environment.msalConfig.loginUrl}/${environment.msalConfig.tenant}.onmicrosoft.com/${environment.msalConfig.signInPolicy}`
    }
  },
  authorityDomain: environment.msalConfig.loginUrl
};

export function msalInstanceFactory(): IPublicClientApplication {
  const currentOrigin = window.location.origin;

  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.clientId,
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      knownAuthorities: [b2cPolicies.authorityDomain],
      redirectUri: currentOrigin,
      postLogoutRedirectUri: currentOrigin
    },
    cache: {
      cacheLocation: 'localStorage'
    }
  });
}

export function msalInterceptorConfig(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.apiUrl, [environment.msalConfig.defaultScopeName]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  }
}

export function msalGuardConfig(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['openid', environment.msalConfig.defaultScopeName]
    }
  };
}
